import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Alert,
  Box,
} from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { useBilling } from '../hooks/useBilling';

export default function PlanComplianceGate({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    isLoading,
    needsEmployeeReduction,
    activeEmployeeCount,
    maxActiveEmployees,
    effectivePlan,
  } = useBilling();

  if (isLoading) return children;

  if (!needsEmployeeReduction) return children;

  const isBillingPage = location.pathname.startsWith('/settings/billing');

  if (isBillingPage) return children;

  return (
    <>
      {children}
      <Dialog open maxWidth="sm" fullWidth disableEscapeKeyDown PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle sx={{ fontWeight: 800, display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningAmber color="warning" />
          Απαιτείται ενέργεια
        </DialogTitle>
        <DialogContent>
          <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
            Το {effectivePlan === 'free' ? 'Free' : 'τρέχον'} plan επιτρέπει έως {maxActiveEmployees} ενεργούς υπαλλήλους.
            Έχετε {activeEmployeeCount} ενεργούς.
          </Alert>
          <Typography color="text.secondary">
            Για να συνεχίσετε, μειώστε τους ενεργούς υπαλλήλους στο Προσωπικό ή αναβαθμίστε το πλάνο σας.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2.5 }}>
          <Button
            variant="outlined"
            onClick={() => navigate('/staff')}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            Πήγαινε στο Προσωπικό
          </Button>
          <Button
            variant="contained"
            onClick={() => navigate('/settings/billing')}
            sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
          >
            Αναβάθμιση
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{ position: 'fixed', inset: 0, bgcolor: 'rgba(0,0,0,0.25)', zIndex: 1299, pointerEvents: 'all' }} />
    </>
  );
}
